<template>
  <v-container>
    <div><label>When do you want this alert to expire?</label></div>
    <div class="expiration-display" v-if="expirationDate">
      Expire {{ expirationDate }}
    </div>
    <v-select
      :items="expirationOptions"
      v-model="selectedExpirationOptions"
      @change="selectedExpirationChanged"
      solo
      class="expiration-input"
      item-text="name"
      item-value="id"
      return-object
    ></v-select>
  </v-container>
</template>
<script>
import dayjs from "dayjs";

import { EXPIRATION_OPTIONS } from "@/common/constants/alert.js";

const EMITTED_ACTIONS = {
  INPUT: "input",
};

export default {
  name: "ExpirationEditor",
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    alert: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      selectedExpirationOptions: this.value
        ? JSON.parse(JSON.stringify(this.value))
        : null,
      expirationOptions: EXPIRATION_OPTIONS,
    };
  },
  methods: {
    selectedExpirationChanged(value) {
      this.$emit(EMITTED_ACTIONS.INPUT, value);
    },
  },
  watch: {
    value: {
      handler() {
        this.selectedExpirationOptions = JSON.parse(JSON.stringify(this.value));
      },
      deep: true,
    },
    "alert.expiration": {
      handler() {
        if (this.alert.expiration) {
          this.selectedExpirationOptions = JSON.parse(
            JSON.stringify(this.alert.expiration)
          );
          this.selectedExpirationChanged(this.alert.expiration);
        }
      },
      deep: true,
    },
  },
  computed: {
    expirationDate() {
      if (
        !this.selectedExpirationOptions ||
        !this.selectedExpirationOptions.id
      ) {
        return null;
      }

      return dayjs()
        .add(
          this.selectedExpirationOptions.value,
          this.selectedExpirationOptions.type
        )
        .format("MMM DD, YYYY");
    },
  },
};
</script>
<style scoped>
.expiration-input >>> .v-input__slot {
  border-radius: 5px !important;
}
.expiration-input >>> .v-text-field__details {
  display: none;
}
.expiration-display {
  color: #3eaeff;
  font-size: 12px;
  padding: 5px 0;
}
</style>
